import { toHttpDate } from '@/wabunka-src/common/utils/httpDate';

export const useLastModifiedHeader = (revisedAt: string | undefined): void => {
  // 開発時のクライアントでは useResponseHeader への代入が NUXT_E1010 を出すため、SSR でだけ付ける
  if (import.meta.client) {
    return;
  }

  const httpDate = toHttpDate(revisedAt);
  if (!httpDate) {
    return;
  }

  useResponseHeader('Last-Modified').value = httpDate;

  // ページ HTML は Cache-Control を持たず、Last-Modified だけを足すとブラウザが経過時間の 1 割ほど再検証なしに使い回す（RFC 9111 §4.2.2）
  const cacheControl = useResponseHeader('Cache-Control');
  if (!cacheControl.value) {
    cacheControl.value = 'no-cache';
  }
};
